import {Filter, type FilterProps} from '@github-ui/filter'

import {getCustomPropertiesProviders, type PropertyDefinition} from './providers/custom-properties'
import {getAllDateProviders} from './providers/date'
import {LanguageStaticFilterProvider} from './providers/languages'
import {getAllNumberProviders} from './providers/number'
import {getAllStaticProviders} from './providers/static'

export type {PropertyDefinition}

interface Props extends Omit<FilterProps, 'providers'> {
  definitions: PropertyDefinition[]
  canUseNone: boolean
}

export function ReposFilter({definitions, canUseNone, ...props}: Props) {
  const providers = [
    ...getAllStaticProviders(),
    ...getAllNumberProviders(),
    ...getAllDateProviders(),
    ...getCustomPropertiesProviders(definitions, canUseNone),
    new LanguageStaticFilterProvider(),
  ]

  return <Filter variant="input" {...props} providers={providers} />
}

try{ ReposFilter.displayName ||= 'ReposFilter' } catch {}